import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
import { useTranslation } from 'react-i18next';
// import './ContactForm.scss';
import { store } from 'react-notifications-component';
import { useHistory } from 'react-router';
import { Modal, Button } from '@material-ui/core';
// import paytabs from '../../assets/imgs/payments/paytabs.png';
import mada from '../../assets/imgs/payments/mada.png';
import paypal from '../../assets/imgs/payments/paypal.png';
import VisaLogo from '../../assets/imgs/payments/VisaLogo.png';
import Mastercardlogo from '../../assets/imgs/payments/Mastercard-logo.png';
import stcpay from '../../assets/imgs/payments/stcpay.png';
import applepay from '../../assets/imgs/payments/applepay.png';
import close from '../../assets/imgs/icons/close.png';

import './PayForm.scss';
import Countdown from 'react-countdown';
import pakage_request from '../../apis/request-project-api/pakage_request';
import Cookies from 'js-cookie';
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const PayForm = () => {
  const { t, i18n } = useTranslation();
  const [Active, setActive] = useState(0);

  const toggleActive = (id) => () => {
    setActive(id);
  };
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };
  const baseFormStr = 'request_project_page.request_project_form';
  const history = useHistory();

  const Completionist = () => (
    <Button className="btn">
      <a
        href={`http://testwebsiteapi.fatoorah.sa/createNewLink?id=${userId}`}
        rel="noreferrer"
        onClick={handleClose}>
        <span className="btn-span">{t('create_project.complate_payment')}</span>
      </a>
    </Button>
  );

  useEffect(() => {
    setActive(0);
  }, []);
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span className="wait">
          {t('create_project.wait')} {seconds}
        </span>
      );
    }
  };

  const CONTACT_FORM_SCHEMA = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        first_name: '',
        // project_details: '',
        phone_number: '',
        address: '',
        tax_number: '',
        activity: ''
      }}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        try {
          if (Active) {
            setSubmitting(true);
            await sleep(500);
            const fetchedData = await pakage_request(
              // history.location.state.values,
              // i18n.language,
              // history.location.state.selectedPakage,
              // history.location.state.PosCount,
              // history.location.state.TotlePrice,
              // history.location.state.DisabledValue,
              // history.location.state.DisabledId,
              // Active
              history.location.state.values,
              history.location.state.activity_id,
              i18n.language,
              history.location.state.selectedPakage,
              history.location.state.PosCount,
              history.location.state.TotlePrice,
              history.location.state.DisabledValue,
              history.location.state.DisabledId,
              history.location.state.sollemKey,
              Active
            );

            if (fetchedData && fetchedData.response_code === 200) {
              setSubmitting(false);
              resetForm();
              store.addNotification({
                title: fetchedData.message,
                message: fetchedData.message,
                type: 'success',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                  duration: 2000,
                  showIcon: true,
                  onScreen: true
                }
              });
              Cookies.remove('currentUser');
              if (history.location.state.selectedPakage !== 1) {
                window.location.href = fetchedData.data.redirect_url;
              }
            } else if (fetchedData && fetchedData.response_code === 201) {
              setUserId(fetchedData.data.id);
              setOpen(true);
            } else {
              setSubmitting(false);

              store.addNotification({
                title: `${t(
                  'request_project_page.request_project_form.send_btn.title_message_error'
                )}`,
                message: fetchedData.message,
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                  duration: 2000,
                  showIcon: true,
                  onScreen: true
                }
              });
            }
          } else {
            setSubmitting(false);
            store.addNotification({
              // title: `${t('request_project_page.request_project_form.send_btn.title_message_error')}`,
              message: `${t('request_project_page.request_project_form.send_btn.Payment_type')}`,
              type: 'danger',
              insert: 'top',
              container: 'top-right',
              animationIn: ['animate__animated', 'animate__fadeIn'],
              animationOut: ['animate__animated', 'animate__fadeOut'],
              dismiss: {
                duration: 2000,
                showIcon: true,
                onScreen: true
              }
            });
          }
        } catch (error) {
          setSubmitting(false);
          store.addNotification({
            title: `${t('request_project_page.request_project_form.send_btn.title_message_error')}`,
            message: 'حاول فى وقت لاحق',
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
              duration: 2000,
              showIcon: true,
              onScreen: true
            }
          });
        }

        ////////////////////////////////////////////////////////////////////////////
      }}
      validationSchema={CONTACT_FORM_SCHEMA}>
      {({ values, isSubmitting, handleSubmit, errors, touched, setSubmitting, resetForm }) => (
        <>
          <form
            onSubmit={handleSubmit}
            className={`pay-form ${i18n.dir()}`}
            // autoComplete="off"

            id="pay-form">
            <div className="features-item-header ">
              <h1 className="h1-text section_header">{t('pay_page.main_title')}</h1>
              {/* <h1 className="h1-text section_header header_line">??????</h1> */}
              {/* {renderAboutUs()} */}
            </div>
            <div
              className={`pay-box ${Active === 1 ? 'active' : 'notactive'}  ${i18n.dir()}`}
              onClick={toggleActive(1)}>
              <div className="cirle">
                <div className="big"></div>
              </div>
              <div className="related-payments">
                <div>
                  <img src={mada} alt="mada" />
                </div>
                <div>
                  <img src={Mastercardlogo} alt="Mastercardlogo" />
                </div>
                <div>
                  <img src={paypal} alt="paypal" />
                </div>
                <div>
                  <img src={VisaLogo} alt="VisaLogo" />
                </div>
                <div>
                  <img src={applepay} alt="applepay" />
                </div>
              </div>
              <div className="main-payments">{/* <img src={paytabs} alt="paytabs" /> */}</div>
            </div>

            <div
              className={`pay-box diable ${Active === 2 ? 'active' : 'notactive'} ${i18n.dir()}`}>
              <div className="cirle">
                <div className="big"></div>
              </div>
              <div className="related-payments"></div>
              <div className="main-payments">
                <img src={stcpay} alt="stcpay" />
              </div>
            </div>
            {/* <div
              className={`pay-box diable ${Active === 3 ? 'active' : 'notactive'} ${i18n.dir()}`}>
              <div className="cirle">
                <div className="big"></div>
              </div>
              <div className="related-payments"></div>
              <div className="main-payments">
                <img src={applepay} alt="applepay" />
              </div>
            </div> */}
            <div className="form-field-wrapper project-details-field-wrap  fffff">
              <ButtonWithLoading
                isSubmitting={isSubmitting}
                errors={errors}
                btnText={t(`${baseFormStr}.pay_btn.title`)}
                loadingMsg={t(`${baseFormStr}.pay_btn.loading`)}
                className="submit-btn submit-form-btn"
                form="pay-form"
              />
            </div>
          </form>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
            <div className={`modal ${i18n.dir()}`}>
              <Button onClick={handleClose} justify="center" className="close">
                <img src={close} alt="close" width="20" height="20" />
              </Button>
              <div className="text">{t('create_project.notcomplate_payment')}</div>

              <Countdown date={Date.now() + 60000} renderer={renderer} />
            </div>
          </Modal>
        </>
      )}
    </Formik>
  );
};

export default PayForm;
